export default {
    push: {
        turnOn: 'Turn on push notifications',
        on: 'Push notifications on',
        turnOff: 'Turn off',
        blocked: 'Blocked in browser settings',
        blockedHint: 'Allow notifications for this site in your browser to turn them on.',
        turnOnHint: 'Get notified even when Studio is closed.',
        enableFailed: "Couldn't turn on push notifications. Please try again.",
        disableFailed: "Couldn't turn off push notifications. Please try again.",
    },
}
